import * as Sentry from '@sentry/react';

const isError = e => e instanceof Error;

const logException = err => {
  let error = err;

  if (!isError(error)) {
    if (typeof error === 'string') {
      error = new Error(error);
    } else {
      error = new Error(JSON.stringify(error));
    }
  }

  Sentry.captureException(error);
  if (process.env.NODE_ENV === 'development') {
    if (typeof window !== 'undefined') {
      window.console && console.error && console.log(error);
    }
  }
};

export default logException;
